import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Uploader from './Uploader';
import MamAssetCard from './MamAssetCard';
import Filter from '../../Tabs/Filter';
import LoadIcon from '../../LoadIcon';
import getMamObjectsListWithTotal from '../../../api/graphql/queries/getMamObjectsListWithTotal';

const PER_PAGE = 50;

const SingleObjUploaderWithSelector = ({ selectCallback }) => {
  const [selected, setSelected] = useState([]);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [imagesOnly, setImagesOnly] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(true);
  const searchDebounce = useRef();
  const requestId = useRef(0);

  const fetchPage = (offset, activeSearch, activeImagesOnly, append) => {
    setIsLoading(true);
    requestId.current += 1;
    const id = requestId.current;
    getMamObjectsListWithTotal({
      type: activeImagesOnly ? ['image'] : undefined,
      search: activeSearch || undefined,
      sort: 'newest',
      offset,
      limit: PER_PAGE,
    }).then((res) => {
      if (!isMounted.current || id !== requestId.current) return;
      if (res) {
        if (append) {
          setItems(prev => [...prev, ...(res.mamObjects || [])]);
        } else {
          setItems(res.mamObjects || []);
        }
        setTotal(res.total || 0);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchPage(0, search, imagesOnly, false);
  }, [search, imagesOnly]);

  useEffect(() => () => { isMounted.current = false; clearTimeout(searchDebounce.current); }, []);

  const updateSearch = (val) => {
    clearTimeout(searchDebounce.current);
    searchDebounce.current = setTimeout(() => setSearch(val), 300);
  };

  const toggleSelected = (slugName) => {
    const obj = items.find(i => i.assetSlugName === slugName);
    if (selected.length && selected[0].assetSlugName === slugName) {
      setSelected([]);
    } else {
      setSelected([obj]);
    }
  };

  return (
    <div className="px-5">
      <Uploader multiple={false} handleMoreItems={() => fetchPage(0, search, imagesOnly, false)} />
      <Filter style="xxl1:my-2 xxxl:mt-2" updateSearch={updateSearch} />
      <label htmlFor="imagesOnly" className="font-americaMonoRegular text-xxs uppercase flex items-center my-1">
        <input type="checkbox" id="imagesOnly" name="imagesOnly" checked={imagesOnly} onChange={() => setImagesOnly(!imagesOnly)} className="mr-2" />
        Images only
      </label>
      <div className="w-full flex flex-row flex-wrap py-2 overflow-y-scroll h-96 xxxl:h-carouselMD xxl1:h-72 justify-center">
        {items.map(obj => (
          <div key={obj.assetSlugName} className={selected.length && selected[0].assetSlugName === obj.assetSlugName ? 'border-2 border-white rounded' : ''}>
            <MamAssetCard obj={obj} onOpen={toggleSelected} small />
          </div>
        ))}
        {isLoading && <LoadIcon color="#FFFFFF" />}
      </div>
      {!isLoading && items.length < total && (
        <button type="button" className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-greyFilter m-2" onClick={() => fetchPage(items.length, search, imagesOnly, true)}>
          {`Load more (${items.length}/${total})`}
        </button>
      )}
      {selected.length > 0 && !isLoading && (
        <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-greyFilter m-2 ml-1 mb-4" type="button" onClick={() => selectCallback && selectCallback(selected)}>
          Select
        </button>
      )}
    </div>
  );
};

SingleObjUploaderWithSelector.propTypes = {
  selectCallback: PropTypes.func,
};

SingleObjUploaderWithSelector.defaultProps = {
  selectCallback: null,
};

export default SingleObjUploaderWithSelector;
